const SESSION_KEY_PREFIX = 'progressMigrationModalHandled'

export function getProgressMigrationModalSessionKey(userId: number): string {
  return `${SESSION_KEY_PREFIX}:${userId}`
}

export function isProgressMigrationModalHandled(userId: number): boolean {
  if (typeof window === 'undefined') return false
  return sessionStorage.getItem(getProgressMigrationModalSessionKey(userId)) === 'true'
}

export function markProgressMigrationModalHandled(userId: number): void {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(getProgressMigrationModalSessionKey(userId), 'true')
}

export function clearProgressMigrationModalSessionForUser(userId: number): void {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(getProgressMigrationModalSessionKey(userId))
}
